import { render, staticRenderFns } from "./EditModelPublisherPermissions.vue?vue&type=template&id=d3fc3c2c"
import script from "./EditModelPublisherPermissions.vue?vue&type=script&lang=js"
export * from "./EditModelPublisherPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports